import { Alert } from 'foundations-components/transitional/components/Alert';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CopySection from '../shared/CopySection';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExternalPageInstructions = ({
  hasError,
  embedCode,
  onCopyClick
}) => {
  if (hasError) {
    return /*#__PURE__*/_jsxs(Alert, {
      use: "inline",
      type: "warning",
      closeable: false,
      "data-test-id": "external-embed-code-error",
      marginBlock: "200",
      paddingBlock: "300",
      children: [/*#__PURE__*/_jsx(Flex, {
        alignItems: "baseline",
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(Text, {
          typography: 'heading-50',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "embeddingInstructions.externalPage.error.title"
          })
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embeddingInstructions.externalPage.error.description"
      })]
    });
  }
  if (!embedCode) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  return /*#__PURE__*/_jsx(CopySection, {
    textToCopy: embedCode,
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embeddingInstructions.externalPage.description"
    }),
    onCopyClick: onCopyClick
  });
};
export default ExternalPageInstructions;